<script lang="ts">
  import Button from "./Button.svelte";
  import InfoButton from "./InfoButton.svelte";

  export const bookNowUrl: string = "";
  export const websiteUrl: string = "";
  export let businessCode: string;
  export let isShell: boolean = false;
  export let checkoutEnabled: boolean = false;
  export let checkoutUrl: string;
</script>

<style>
  .float-bottom {
    position: fixed;
    bottom: 0px;
    right: 0;
    width: 250;
    z-index: 999;
  }
</style>

<div class="booking-footer float-bottom">
  <div class="container">
    <div class="text-center my-3 d-flex justify-content-end">
      {#if !isShell}
        {#if !checkoutEnabled}
          <Button {businessCode} btnClasses={"btn btn-primary btn-rounded mr-3"} />
        {/if}
      {/if}
    </div>
  </div>
</div>
